<script lang="ts">
	import { getClassicWebUrl, getCurrentUser, getUserActions } from "$lib/components/currentUser";

	const CLASSIC_WEB_URL = getClassicWebUrl();
	const { loggedInAs } = getUserActions();
	const { name } = getCurrentUser();
</script>

<div class="bg-red-600 py-4" role="banner">
	<div class="container-1200 lg:no-wrap flex flex-wrap justify-between text-white">
		<p class="flex">
			<span class="material-icons mr-1.5 mt-0.5 text-18">warning</span>
			<span class="font-bold">You ({loggedInAs.adminName}) are logged in as {name}</span>
		</p>
		<a href="{CLASSIC_WEB_URL}/app/users/logout" class="ml-2 hidden font-bold text-white lg:inline-block">Log out</a>
	</div>
</div>
